var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueAssistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#C1E1F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 11.5C8.41489 11.5 7.00532 12.2653 6.10792 13.453C5.91478 13.7086 5.81821 13.8364 5.82136 14.0091C5.8238 14.1426 5.90761 14.3109 6.01261 14.3933C6.14852 14.5 6.33686 14.5 6.71354 14.5H13.2863C13.663 14.5 13.8513 14.5 13.9872 14.3933C14.0922 14.3109 14.176 14.1426 14.1785 14.0091C14.1816 13.8364 14.0851 13.7086 13.8919 13.453C12.9945 12.2653 11.585 11.5 9.99993 11.5Z",
    stroke: "#026AA2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 10C11.2426 10 12.2499 8.99264 12.2499 7.75C12.2499 6.50736 11.2426 5.5 9.99993 5.5C8.75728 5.5 7.74993 6.50736 7.74993 7.75C7.74993 8.99264 8.75728 10 9.99993 10Z",
    stroke: "#026AA2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueAssistant);
export default __webpack_public_path__ + "static/media/blueAssistant.15e6b9b18265322a5de9543529dc84f2.svg";
export { ForwardRef as ReactComponent };